import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CreditofferService } from '../../../services/creditoffer.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  offerNumber: string=null;

  constructor(private route: ActivatedRoute,private offerService:CreditofferService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(param => {
      if (this.offerNumber == null || this.offerNumber == '') {
        this.offerNumber = this.offerService.offerConfirmationNumber;
        //reset the offer number in the service
        this.offerService.offerConfirmationNumber = null;
      }
      
    })
  }

}
